<div class="container">


    <form [formGroup]="PerfilForm" novalidate>
        <div class="ml-2 mr-2">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab"
                        aria-controls="home" aria-selected="true">
                        Datos Personales
                        <em class="mdi mdi-account-box-outline"></em>
                    </a>
                </li>
            </ul>
            <div class="row  mt-2">
                <div class="col-md-12">

                    <div class="progress" id="progress" *ngIf="progress">
                        <div class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                            role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"
                            style="width: 100%"></div>
                    </div>
                    <div class="alert alert-success alert-dismissible fade show mt-2 lg-success" role="alert"
                        *ngIf="alertSucces">
                        <strong>Se ha generado la actualizacion!</strong> de forma exitosa.
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="alert alert-warning alert-dismissible fade show mt-2 lg-warning" role="alert"
                        *ngIf="alertError">
                        <strong>ha fallado la actualización!</strong>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                    <div class="border border-success rounded">
                        <div class="alert alert-info mt-2 ml-2 mr-2" role="alert">
                            Estimado Postulante: Debes completar los datos indicados mas adelante ya que ellos serán
                            parte importante del
                            proceso de matrícula.
                        </div>

                        <div class="ml-3 mr-3">
                            <div class="card border border-success mt-3">
                                <h5 class="card-header">Datos Personales
                                    <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#DP"
                                        role="button" aria-expanded="true" aria-controls="DP"></a>
                                </h5>

                                <div class="collapse show" id="DP">
                                    <div class="card-body">
                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-6">
                                                        <label>Nacionalidad <span class="text-danger">*</span></label>
                                                        <select formControlName="Nacionalidad"
                                                            class="form-control form-control-sm"
                                                            (change)="ChangeNacionalidad($event)">
                                                            <option value="">Seleccione</option>
                                                            <option value="1">Chilena</option>
                                                            <option value="2">Otra</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <label
                                                            *ngIf="PerfilForm.controls.Nacionalidad.value == '1'">RUT</label>
                                                        <label
                                                            *ngIf="PerfilForm.controls.Nacionalidad.value != '1'">Pasaporte</label>
                                                        <input type="text" formatRut
                                                            class="form-control form-control-sm"
                                                            placeholder="Ingresa tu RUT con guión y sin puntos"
                                                            formControlName="Rut" id="txtRut"
                                                            *ngIf="PerfilForm.controls.Nacionalidad.value === '1'">
                                                        <span class="text-muted" *ngIf="
                                                            PerfilForm.controls.TipoDocumentos.value === '1' &&
                                                            !PerfilForm.controls.Rut.valid &&
                                                            PerfilForm.controls.Rut?.touched
                                                          ">Por favor, ingrese un RUT válido</span>
                                                        <input type="text" class="form-control form-control-sm"
                                                            placeholder="Ingresa tu Pasaporte"
                                                            formControlName="Passaporte" id="txtPasaporte"
                                                            *ngIf="PerfilForm.controls.Nacionalidad.value !== '1'">
                                                        <span class="text-muted" *ngIf="
                                                          PerfilForm.controls.TipoDocumentos.value !== '1' &&
                                                          !PerfilForm.controls.Passaporte.valid &&
                                                          PerfilForm.controls.Passaporte?.touched
                                                        ">Por favor, ingrese un Passaporte válido</span>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-6">
                                                        <label>Número de serie</label>
                                                        <input (keyup)="formatearSerieRut()" type="text"
                                                            class="form-control form-control-sm"
                                                            placeholder="Ingresa tu número de serie (sin puntos)"
                                                            formControlName="SerialRut" id="txtSerial" />
                                                        <span class="text-muted" *ngIf="
                                                        PerfilForm.controls.SerialRut?.touched && !PerfilForm.controls.SerialRut.valid
                                                      ">Ingresa tu número de serie. Ej: 123456789 (cédula nueva)/
                                                            A123456789 (cédula antigua)</span>
                                                    </div>
                                                    <div class="col-sm-6">

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2" *ngIf="PerfilForm.controls.Nacionalidad.value == '1'">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-6">

                                                        <label>Primer Nombre <span class="text-danger">*</span></label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            appOnlyLettersInput placeholder="Ingresa primer nombre"
                                                            formControlName="Nombre">
                                                        <span class="text-muted"
                                                            *ngIf="!PerfilForm.controls['Nombre'].valid && PerfilForm.controls['Nombre']?.touched">Por
                                                            favor, ingrese un nombre válido</span>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <label>Segundo Nombre</label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            placeholder="Ingresa segundo nombre" appOnlyLettersInput
                                                            formControlName="Nombre2">
                                                        <span class="text-muted"
                                                            *ngIf="!PerfilForm.controls['Nombre2'].valid && PerfilForm.controls['Nombre2']?.touched">Por
                                                            favor, ingrese un segundo nombre válido</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-6">
                                                        <label>Apellido Paterno <span
                                                                class="text-danger">*</span></label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            placeholder="Ingresa tu apellido paterno"
                                                            appOnlyLettersInput formControlName="ApellidoP">
                                                        <span class="text-muted"
                                                            *ngIf="!PerfilForm.controls['ApellidoP'].valid && PerfilForm.controls['ApellidoP']?.touched">Por
                                                            favor, ingrese un apellido válido</span>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <label>Apellido Materno</label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            placeholder="Ingresa tu apellido materno"
                                                            appOnlyLettersInput formControlName="ApellidoM">
                                                        <span class="text-muted"
                                                            *ngIf="!PerfilForm.controls['ApellidoM'].valid && PerfilForm.controls['ApellidoM']?.touched">Por
                                                            favor, ingrese un apellido válido</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-6">
                                                        <label>Estado Civil <span class="text-danger">*</span></label>
                                                        <select formControlName="EstadoCivil"
                                                            class="form-control form-control-sm">
                                                            <option value="">Seleccione</option>
                                                            <option value="1">Soltero/a</option>
                                                            <option value="2">Casado/a</option>
                                                            <option value="3">Divorciado/a</option>
                                                            <option value="4">Viudo/a</option>
                                                            <option value="5">Conviviente Civil</option>
                                                        </select>
                                                    </div>

                                                    <div class="col-sm-6">
                                                        <label>Género <span class="text-danger">*</span></label>
                                                        <select formControlName="Genero"
                                                            class="form-control form-control-sm">
                                                            <option value="">Seleccione</option>
                                                            <option value="1">Masculino</option>
                                                            <option value="2">Femenino</option>
                                                        </select>
                                                        <span class="text-muted"
                                                            *ngIf="!PerfilForm.controls['Genero'].valid && PerfilForm.controls['Genero']?.touched">Por
                                                            favor, selecionar un género válido</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2 ">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-6">
                                                        <label>Etnia <span class="text-danger">*</span></label>
                                                        <select formControlName="Etnia"
                                                            class="form-control form-control-sm">
                                                            <option value="">Seleccione</option>
                                                            <option value="1">Si</option>
                                                            <option value="2">No</option>
                                                        </select>
                                                    </div>

                                                    <div class="col-sm-6">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-sm-6">
                                                <label>¿Presenta alguna condicion de discapacidad? <span
                                                        class="text-danger">*</span></label>
                                                <select formControlName="PresentaDiscapacidad"
                                                    class="form-control form-control-sm">
                                                    <option value="">Seleccione</option>
                                                    <option value="1">Si</option>
                                                    <option value="2">No</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-6">
                                                <label>Fecha de nacimiento
                                                    <span class="text-danger">*</span>
                                                    <span
                                                        *ngIf="PerfilForm.controls['FechaNacimiento'].hasError('required') || PerfilForm.controls['FechaNacimiento'].hasError('ValidarFecha')"
                                                        class="text-danger">*</span>
                                                </label>
                                                <input type="date" class="form-control form-control-sm" id=""
                                                    placeholder="--" formControlName="FechaNacimiento">
                                                <span class="text-muted"
                                                    *ngIf="!PerfilForm.controls['FechaNacimiento'].valid && PerfilForm.controls['FechaNacimiento']?.touched">Por
                                                    favor, ingrese una fecha válida. Debes ser mayor de 17 años y menor
                                                    de 70 años</span>
                                            </div>
                                        </div>
                                        <div *ngIf="PerfilForm.controls['PresentaDiscapacidad']?.value == '1'"
                                            class="row mt-2">
                                            <div class="form-check">
                                                <br />
                                                <input (change)="FieldsChange($event)" class="form-check-input"
                                                    type="checkbox" id="DeseaRecibirAsesoria"
                                                    formControlName="DeseaRecibirAsesoria" />

                                                <label class="form-check-label" for="DeseaRecibirAsesoria">
                                                    ¿Desea recibir orientación antes de matricularse?
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="card border border-success mt-1">
                                <h5 class="card-header">Datos de contactibilidad
                                    <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#DC"
                                        role="button" aria-expanded="true" aria-controls="DC"></a>
                                </h5>
                                <div class="collapse show" id="DC">
                                    <div class="card-body">
                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-6">

                                                        <label>Celular <span class="text-danger">*</span></label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            placeholder="Ingresa tu teléfono Celular"
                                                            formControlName="Celular" appOnlyNumbersInput
                                                            pattern="[0-9 ]*">
                                                        <span class="text-muted"
                                                            *ngIf="!PerfilForm.controls['Celular'].valid && PerfilForm.controls['Celular']?.touched">Por
                                                            favor, ingrese un telefóno válido</span>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <label>Correo electrónico <span
                                                                class="text-danger">*</span></label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            placeholder="Ingresa tu correo electrónico"
                                                            formControlName="CorreoElectronico">
                                                        <span class="text-muted"
                                                            *ngIf="!PerfilForm.controls['CorreoElectronico'].valid && PerfilForm.controls['CorreoElectronico']?.touched">Por
                                                            favor, ingrese un correo electrónico válido</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2 ">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-6">

                                                        <label>Teléfono Fijo</label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            placeholder="Ingresa tu teléfono (opcional)"
                                                            formControlName="Telefono" appOnlyNumbersInput
                                                            prefijo="(2) ">
                                                        <span class="text-muted"
                                                            *ngIf="!PerfilForm.controls['Telefono'].valid && PerfilForm.controls['Telefono']?.touched">Por
                                                            favor, ingrese un telefono válido</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card border border-success mt-1">
                                <h5 class="card-header">Datos de Dirección
                                    <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#DD"
                                        role="button" aria-expanded="true" aria-controls="DD"></a>
                                </h5>
                                <div class="collapse show" id="DD">
                                    <div class="card-body">
                                        <div class="row mt-2 ">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-6">
                                                        <label>País <span class="text-danger">*</span></label>
                                                        <select formControlName="Pais"
                                                            class="form-control form-control-sm">
                                                            <option value="">Seleccione</option>
                                                            <option *ngFor="let pais of Paises" value={{pais.Id}}>
                                                                {{pais.Nombre}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <label>Región <span class="text-danger">*</span></label>
                                                        <select class="form-control form-control-sm"
                                                            formControlName="Region" (change)="ChangeRegion($event)">
                                                            <option value='' selected>Seleccionar</option>
                                                            <option *ngFor="let region of Regiones" value={{region.Id}}>
                                                                {{region.Nombre}}</option>
                                                        </select>
                                                        <span class="text-muted"
                                                            *ngIf="!PerfilForm.controls['Region'].valid && PerfilForm.controls['Region']?.touched">Por
                                                            favor, selecionar una región válida</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mt-2 ">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-6">
                                                        <label>Ciudad <span class="text-danger">*</span></label>
                                                        <select class="form-control form-control-sm"
                                                            formControlName="Ciudad">
                                                            <option value='' selected>Seleccionar</option>
                                                            <option *ngFor="let ciudad of Ciudades" value={{ciudad.Id}}>
                                                                {{ciudad.Nombre}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <label>Comuna <span class="text-danger">*</span></label>
                                                        <select class="form-control form-control-sm"
                                                            formControlName="Comuna">
                                                            <option value='' selected>Seleccionar</option>
                                                            <option *ngFor="let comuna of Comunas" value={{comuna.Id}}>
                                                                {{comuna.Nombre}}</option>
                                                        </select>
                                                        <span class="text-muted"
                                                            *ngIf="!PerfilForm.controls['Comuna'].valid && PerfilForm.controls['Comuna']?.touched">Por
                                                            favor, selecionar una comuna válida</span>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mt-2 ">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-6">
                                                        <label>Calle <span class="text-danger">*</span></label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            placeholder="Ingresa una direccion" formControlName="Calle">
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label>Número</label>
                                                        <input class="form-control form-control-sm" id="CalleNro"
                                                            formControlName="CalleNro" type="text">
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label>Departamento / Casa</label>
                                                        <input class="form-control form-control-sm" id="Dpto"
                                                            formControlName="CalleDpto" type="text">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>


                    </div>

                </div>
                <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                    <div class="border border-success rounded">
                        <div class="ml-3 mr-3">
                            <div class="card border border-success mt-3">
                                <h5 class="card-header">Datos Bancarios
                                    <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#DB"
                                        role="button" aria-expanded="true" aria-controls="DB"></a>
                                </h5>
                                <div class="collapse show" id="DB">
                                    <div class="card-body">
                                        <div class="row mt-2 ">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-6">
                                                        <label>Banco</label>
                                                        <select class="form-control form-control-sm"
                                                            formControlName="Banco">
                                                            <option value="">Seleccione</option>
                                                            <option value="BANCO SANTANDER">BANCO SANTANDER</option>
                                                            <option value="BANCO SANTANDER BANEFE">BANCO SANTANDER
                                                                BANEFE
                                                            </option>
                                                            <option value="BANCO ITAU">BANCO ITAU</option>
                                                            <option value="BCI-TBANC">BCI-TBANC</option>
                                                            <option value="BANCO FALABELLA">BANCO FALABELLA</option>
                                                            <option value="CORPBANCA">CORPBANCA</option>
                                                            <option value="BANCO DE CHILE / EDWARDS CITI">BANCO DE CHILE
                                                                /
                                                                EDWARDS CITI
                                                            </option>
                                                            <option value="BANCOESTADO">BANCOESTADO</option>
                                                            <option value="BANCO BICE">BANCO BICE</option>
                                                            <option value="BANCO SECURITY">BANCO SECURITY</option>
                                                            <option value="BANCO CONSORCIO">BANCO CONSORCIO</option>
                                                            <option value="BANCO RIPLEY">BANCO RIPLEY</option>
                                                            <option value="BANCO INTERNACIONAL">BANCO INTERNACIONAL
                                                            </option>
                                                            <option value="SCOTIABANK">SCOTIABANK</option>
                                                            <option value="COOPEUCH">COOPEUCH</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <label>Tipo Cuenta</label>
                                                        <select class="form-control form-control-sm"
                                                            formControlName="TipoDeCuenta">
                                                            <option value="">Seleccione</option>
                                                            <option value="Cta. Corriente">Cta. Corriente</option>
                                                            <option value="Cta. Vista">Cta. Vista</option>
                                                            <option value="Cta. Ahorro">Cta. Ahorro</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2 ">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-6">
                                                        <label>Numero Cta.</label>
                                                        <input class="form-control form-control-sm" type="text"
                                                            formControlName="NroDeCuenta">
                                                    </div>
                                                    <div class="col-sm-6">

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">

                    <div class=" border border-success rounded">
                        <div class="mr-3 ml-3">
                            <div class="card border border-success mt-3">
                                <h5 class="card-header">Ingrese Antecedentes Educacionales
                                    <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#IAE"
                                        role="button" aria-expanded="true" aria-controls="IAE"></a>
                                </h5>
                                <div class="collapse show" id="IAE">
                                    <div class="card-body">
                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-6">
                                                        <div class="form-group">
                                                            <div class="form-check">
                                                                <input class="form-check-input" type="checkbox"
                                                                    id="EnsenhazaMediaEextranjero"
                                                                    formControlName="EnsenhazaMediaEextranjero">
                                                                <label class="form-check-label"
                                                                    for="EnsenhazaMediaEextranjero">
                                                                    ¿Estudio enseñanza media en el extranjero?
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6">


                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-3">
                                                        <div class="form-group">
                                                            <div class="form-check">
                                                                <input class="form-check-input" type="checkbox"
                                                                    id="PrimeroMedioExterior"
                                                                    formControlName="PrimeroMedioExterior">
                                                                <label class="form-check-label"
                                                                    for="PrimeroMedioExterior">
                                                                    Primero Medio Exterior
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-3">
                                                        <div class="form-group">
                                                            <div class="form-check">
                                                                <input class="form-check-input" type="checkbox"
                                                                    id="SegundoMedioExterior"
                                                                    formControlName="SegundoMedioExterior">
                                                                <label class="form-check-label"
                                                                    for="SegundoMedioExterior">
                                                                    Segundo Medio Exterior
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-3">
                                                        <div class="form-group">
                                                            <div class="form-check">
                                                                <input class="form-check-input" type="checkbox"
                                                                    id="TerceroMedioExterior"
                                                                    formControlName="TerceroMedioExterior">
                                                                <label class="form-check-label"
                                                                    for="TerceroMedioExterior">
                                                                    Tercero Medio Exterior
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-3">
                                                        <div class="form-group">
                                                            <div class="form-check">
                                                                <input class="form-check-input" type="checkbox"
                                                                    id="CuartoMedioExterior"
                                                                    formControlName="CuartoMedioExterior">
                                                                <label class="form-check-label"
                                                                    for="CuartoMedioExterior">
                                                                    Cuarto Medio Exterior
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-2">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox"
                                                            id="CuarsandoCuartoMedio"
                                                            formControlName="CuarsandoCuartoMedio">
                                                        <label class="form-check-label" for="CuarsandoCuartoMedio">
                                                            Estoy cursando cuarto medio
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-6">
                                                        <label>Año de Egreso de EM</label>
                                                        <select formControlName="AnhoEgresoEM"
                                                            class="form-control form-control-sm">
                                                            <option value="" selected>Seleccione</option>
                                                            <option *ngFor="let anho of AnhosEgresos"
                                                                value={{anho.Value}}>
                                                                {{anho.Text}}</option>
                                                        </select>

                                                    </div>
                                                    <div class="col-sm-6">
                                                        <label>Región de Estudio</label>
                                                        <select formControlName="RegionEstudio"
                                                            class="form-control form-control-sm"
                                                            (change)="ChangeRegionColegio($event)">
                                                            <option value="" selected>Seleccione</option>
                                                            <option *ngFor="let regione of RegionesColegios"
                                                                value={{regione.Id}}>
                                                                {{regione.Nombre}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-4">
                                                        <label>Establecimiento Educacional</label>
                                                        <select formControlName="EstablecimientoEducacionl"
                                                            class="form-control form-control-sm">
                                                            <option value="" selected>Seleccione</option>
                                                            <option *ngFor="let estableciminto of Establecimientos"
                                                                value={{estableciminto.Id}}>
                                                                {{estableciminto.Nombre}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-4">
                                                        <label>Tipo de Dependencia</label>
                                                        <select formControlName="TipoDependencia"
                                                            class="form-control form-control-sm">
                                                            <option value="" selected>Seleccione</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-4">

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card border border-success mt-2">
                                <h5 class="card-header">Ingrese sus Notas Enseñanza Media
                                    <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#INEM"
                                        role="button" aria-expanded="true" aria-controls="INEM"></a>
                                </h5>
                                <div class="collapse show" id="INEM">
                                    <div class="card-body">
                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox" id="CursoEM2x1"
                                                            formControlName="CursoEM2x1">
                                                        <label class="form-check-label" for="CursoEM2x1">
                                                            Cursé la enseñanza media bajo la modalidad 2x1
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-3">
                                                        <div class="form-group">
                                                            <div class="form-check">
                                                                <input class="form-check-input" type="checkbox"
                                                                    id="PrimeroMedio2x1"
                                                                    formControlName="PrimeroMedio2x1">
                                                                <label class="form-check-label" for="PrimeroMedio2x1">
                                                                    Primero Medio 2x1
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-3">
                                                        <div class="form-group">
                                                            <div class="form-check">
                                                                <input class="form-check-input" type="checkbox"
                                                                    id="SegundoMedio2x1"
                                                                    formControlName="SegundoMedio2x1">
                                                                <label class="form-check-label" for="SegundoMedio2x1">
                                                                    Segundo Medio 2x1
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-3">
                                                        <div class="form-group">
                                                            <div class="form-check">
                                                                <input class="form-check-input" type="checkbox"
                                                                    id="TerceroMedio2x1"
                                                                    formControlName="TerceroMedio2x1">
                                                                <label class="form-check-label" for="TerceroMedio2x1">
                                                                    Tercero Medio 2x1
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-3">
                                                        <div class="form-group">
                                                            <div class="form-check">
                                                                <input class="form-check-input" type="checkbox"
                                                                    id="CuartoMedio2x1"
                                                                    formControlName="CuartoMedio2x1">
                                                                <label class="form-check-label" for="CuartoMedio2x1">
                                                                    Cuarto Medio 2x1
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <div class="form-group row">

                                                    <div class="col-sm-3">
                                                        <label>Nota 1° medio</label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            formControlName="NotaPrimeroMedio"
                                                            placeholder="Ingresar nota">

                                                    </div>
                                                    <div class="col-sm-3">
                                                        <label>Nota 2° medio</label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            formControlName="NotaSegundoMedio"
                                                            placeholder="Ingresar nota">

                                                    </div>
                                                    <div class="col-sm-3">
                                                        <label>Nota 3° medio</label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            formControlName="NotaTerceroMedio"
                                                            placeholder="Ingresar nota">

                                                    </div>
                                                    <div class="col-sm-3">
                                                        <label>Nota 4° medio</label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            formControlName="NotaCuartoMedio"
                                                            placeholder="Ingresar nota">

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="col-sm-4">
                                                        <label>Puntaje Promedio de PSU</label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            formControlName="PuntajePromedioPsu"
                                                            placeholder="Ingresar promedio PSU">

                                                    </div>
                                                    <div class="col-sm-4">
                                                        <label>Año PSU</label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            formControlName="AnhoPsu" placeholder="Ingresar Año">
                                                    </div>
                                                    <div class="col-sm-4">
                                                        <label>Ranking</label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            formControlName="Ranking" placeholder="Ingresar ranking">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <div class="form-group row">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox"
                                                            id="CertificadoCulminacionEM"
                                                            formControlName="CertificadoCulminacionEM">
                                                        <label class="form-check-label" for="CertificadoCulminacionEM">
                                                            Certificado de Culminación de Enseñanza Media
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-2 mt-2">
                <div class="col-md-12">
                    <a (click)="Actualizar()" class="btn btn-block btn-primary bg-primary"
                        style="background-color: #114B43!important; border-color: #114B43;">Actualizar</a>
                </div>
            </div>
        </div>
    </form>
</div>